//
//  A N E A R   B R O W S E R
//
import React from 'react'
import { CssBaseline } from '@mui/material'
import { ThemeProvider } from '@mui/material/styles'

import UserAuthContainer from './components/Containers/UserAuthContainer'
import UIStateContainer from './components/Containers/UIStateContainer'

import Header from './components/UI/Header'
import BurgerMenu from './components/UI/BurgerMenu'
import DefaultTheme from './DefaultTheme'
import AnearRoutes from './AnearRoutes'
import { BrowserRouter as Router } from 'react-router-dom'

const App = () => {
  return (
    <UserAuthContainer.Provider>
    <UIStateContainer.Provider>
      <ThemeProvider theme={DefaultTheme}>
        <CssBaseline />
        <Router>
          <div style={{ overflowX: 'hidden', width: '100%' }}>
            <Header />
            <AnearRoutes />
            <BurgerMenu />
          </div>
        </Router>
      </ThemeProvider>
    </UIStateContainer.Provider>
    </UserAuthContainer.Provider>
  )
}
export default App
